import FrequentlyAskedQuestions, {
  CategoryQuestion,
} from '@/components/organisms/FrequentlyAskedQuestions/FrequentlyAskedQuestions';

const SELL_MY_CAR_QUESTIONS: CategoryQuestion['questions'] = [
  {
    header: 'How do I sell my car with EV.com?',
    text: "We offer a simple way to sell your car through our network of verified, trusted dealerships. Start by filling out our short online appraisal form to receive a valuation for your vehicle. You'll provide basic details about your car, including the year, make, model, mileage, and overall condition. After uploading images of your vehicle, we'll connect with dealerships on your behalf. Dealers will then contact you directly to arrange the purchase or trade-in of your car.",
  },
  {
    header: 'Can I sell my gas car or truck?',
    text: "Yes! We'll connect you with our network of verified, trusted dealerships that buy gas, electric, and plug-in hybrid vehicles.",
  },
  {
    header: 'Can I trade in my car for an EV?',
    text: 'Yes! Our network of verified, trusted dealerships offers trade-in options for gas-powered vehicles to help you switch to an EV.',
  },
  {
    header: 'How is the value of my car determined?',
    text: "Dealerships use factors such as location, condition, and fair market tools like Black Book to determine your car's value. They will contact you directly to negotiate an offer to buy or trade in your vehicle.",
  },
  {
    header: 'Can I sell my car if I still owe money on it?',
    text: 'Yes! If you still owe money on your vehicle, the dealership will work with you to pay off your current loan. They may handle the loan payoff by deducting the outstanding balance and any fees from your payment. Some dealerships may require you to fully settle the loan and provide proof before purchasing the vehicle.',
  },
  {
    header: "Can I sell my car if I'm leasing it?",
    text: "Yes! First, review your lease contract to find the buyout price. Similar to loan payoffs, the dealer may offer more than what you owe. If not, you'll be responsible for paying the difference.",
  },
  {
    header: 'How do I get paid?',
    text: "We connect you with verified, trusted dealerships that arrange the purchase and handle payment. Typically, you'll be paid via bank transfer or check.",
  },
  {
    header: "I'm still driving my car. Can I sell it?",
    text: 'Yes! Dealerships typically allow for a small variance in mileage without affecting your offer. If you expect a larger variance, you may need to renegotiate the sale price when finalizing the deal.',
  },
  {
    header: 'What paperwork do I need to sell my car?',
    text: "Dealerships typically require the current registration signed by all registered owners, the car title, and a valid ID or driver's license. You may also need to provide warranty information. To complete the sale, you'll likely need to fill out a bill of sale. Check with your local DMV for state-specific requirements.",
  },
  {
    header: "Why haven't I received any offers from dealerships?",
    text: "While our network usually accepts any drivable car for purchase or trade-in, some vehicles may be excluded. This could be due to high repair costs, extensive damage, or being outside the dealership's price range or location.",
  },
];

export const Faq = () => (
  <div className="flex flex-col rounded-none bg-white p-[0px] px-xl md:rounded-medium md:py-[40px]">
    <FrequentlyAskedQuestions
      headingClassName="!mb-s !text-center !text-h2SemiBold !text-black"
      subHeadingClassName="!mb-[40px] !text-center !text-black !text-h4Regular"
      subHeading="Sell your car the EV.com way"
      questionGroups={[{ questions: SELL_MY_CAR_QUESTIONS }]}
    />
  </div>
);
